import * as React from "react";
import { forwardRef } from "react";
const SvgColorStatusS = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ React.createElement("rect", { x: 6, y: 6, width: 12, height: 12, fill: "#64748B" })));
const ForwardRef = forwardRef(SvgColorStatusS);
export { ForwardRef as ReactComponent };
